import { AxiosError } from 'axios';

export type ChoiceValue = { key: string; value: string }[] | null;

export const choiceKeyOf = (value: unknown): string | undefined =>
  Array.isArray(value) ? (value[0] as { key?: string } | undefined)?.key : undefined;

type FieldErrorBody = { entityFieldValues?: Record<string, string[] | string> };

export const fieldErrorsOf = (error: unknown): Record<string, string> => {
  const body = (error as AxiosError<FieldErrorBody>).response?.data;
  const fields = body && !Array.isArray(body) ? body.entityFieldValues : undefined;
  if (!fields || typeof fields !== 'object') {
    return {};
  }

  return Object.fromEntries(
    Object.entries(fields).map(([key, messages]) => [key, Array.isArray(messages) ? messages[0] : messages])
  );
};

type ConflictBody = { detail?: string } | string[];

export const conflictDetail = (error: unknown): string | undefined => {
  const body = (error as AxiosError<ConflictBody>).response?.data;
  return body && !Array.isArray(body) ? body.detail : undefined;
};
